import moment, { unitOfTime } from 'moment';

export type LockTimeType = {
	duration: number;
	difference: unitOfTime.Diff;
};

export const hasOneHourPassed = (startTime: string) => {
	const currentTime = moment();
	const startTimeMoment = moment(startTime);

	const differenceInHours = currentTime.diff(startTimeMoment, 'hours');

	return differenceInHours < 1;
};

export const getLockMessage = (canWithdraw?: boolean) => {
	const forcedUnlockMoment = moment(
		'2025-01-06 00:00:00',
		'YYYY-MM-DD HH:mm:ss',
	);
	const now = moment();

	if (now.isBefore(forcedUnlockMoment)) {
		return `Claim at ${forcedUnlockMoment.format('DD-MMM, hh:mm A')}`;
	}

	return canWithdraw ? 'Withdraw' : 'Claim';
};

export const checkLock = (canWithdraw?: boolean) => {
	return getLockMessage(canWithdraw);
};

export const adjustDate = (isoDateString: string) => {
	const date = moment(isoDateString);
	const dayOfMonth = date.date();

	if (dayOfMonth <= 14) {
		date.add(1, 'month');
	} else {
		date.add(2, 'month').startOf('month');
	}
	const dayOfWeek = date.day();
	if (dayOfWeek === 6) {
		date.add(2, 'days');
	} else if (dayOfWeek === 0) {
		date.add(1, 'days');
	}
	return date.toISOString();
};

export const isPassed = (startTime: string, lock: LockTimeType) => {
	const currentTime = moment();
	const startTimeMoment = moment(startTime);

	const differenceInMinutes = currentTime.diff(
		startTimeMoment,
		lock.difference,
	);

	const newTime = startTimeMoment.add(lock.duration, lock.difference);

	return { isLocked: differenceInMinutes < lock.duration, newTime };
};
